<div class="modal fade show d-block" id="revmodal" tabindex="-1" aria-labelledby="revModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content p-4">
      <div class="d-flex justify-content-end" (click)="redirectToCart()">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <h2 class="h4 text-center mb-2 py-3">
        {{ data.isFreight !== undefined ? (data.isFreight ? 'Freight Products Only!' : 'Non Freight Products Only!') :
        'Notifications!' }}
      </h2>
      <p class="text-center" *ngFor="let message of data.messages">
        {{ message }}
      </p>
      <ng-container *ngIf="data?.totalItems > 1; else elseBlock">
        <div class="col-9 d-flex justify-content-between mx-5 mt-3">
          <button type="button" class="btn btn-continue " data-bs-dismiss="modal"
            (click)="redirectToCheckout()">Continue</button>
          <button type="button" class="btn btn-cancel " data-bs-dismiss="modal"
            (click)="redirectToCart()">Cancel</button>
        </div>
      </ng-container>
      <ng-template #elseBlock>
        <div class="text-center mt-3">
          <button *ngIf="data.proccedToCheckout" type="button" class="btn btn-danger ok-buton" data-bs-dismiss="modal" (click)="redirectToCheckout()">Ok</button>
          <button *ngIf="!data.proccedToCheckout" type="button" class="btn btn-danger ok-buton" data-bs-dismiss="modal" (click)="redirectToCart()">Ok</button>
        </div>
      </ng-template>
    </div>
  </div>
</div>